/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_filter': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M18.67 0H.84a.838.838 0 00-.838.906.849.849 0 00.158.433l6.532 9.2.007.009c.237.32.365.708.366 1.107v7.5a.834.834 0 001.165.779l3.67-1.4a.8.8 0 00.548-.784v-6.092c0-.399.129-.787.366-1.107l.007-.009 6.533-9.2A.848.848 0 0018.67 0z" _fill="#3B3B3B"/>'
  }
})
